import { connect } from "react-redux";
import { setButtonAddCart, setButtonOutOfStock, setButtonViewCart, setContentMessageOutOfStockCart, setHasPrivateReplyAddress, setMessageAddCart, setMessageConfirmCart } from "../../../../store/action/settingPageAction";
import SlateEditor from "../../../shared/components/SlateEditor/editor";
import { useState } from "react";
import { METHOD_TYPE } from "../../../../store/reducers/settingPapgeReducer";
import Switch from "../../../shared/components/Button/switch";

const SettingAutoReply = (props) => {
  const {
    settingPage,
    setMessageAddCart,
    setButtonAddCart,
    setMessageConfirmCart,
    setButtonViewCart,
    setContentMessageOutOfStockCart,
    setButtonOutOfStock,
    setHasPrivateReplyAddress
  } = props;
  const {
    button_add_cart,
    message_add_cart,
    message_confirm_cart,
    content_message_out_of_stock,
    button_view_cart,
    has_message_out_of_stock,
    type,
    has_private_reply_address
  } = settingPage;
  const [editReEngagementMessages, setEditReEngagementMessages] = useState(false);

  return (
    <div className="setting-auto-reply-wrapper">
      <div className="card">
        <div className="card-title mb16">
          <span>
            <div className="svg-next-icon card-title-icon ic-forum">
            </div>
          </span>
          <span>
            Cài đặt trả lời tin nhắn tự động
          </span>
        </div>
        {type === METHOD_TYPE.MANUAL ?
          <div className="setting-auto-reply-box">
            <div className="setting-auto-reply-row ">
              <div className="switch-setting-item-wrapper">
                <div className="item-group display-flex-align-items-center">
                  <div className="switch-box">
                    <Switch isActived={has_private_reply_address} onClick={() => setHasPrivateReplyAddress(!has_private_reply_address ? 1 : 0)}/>
                  </div>
                  <div className="info-container">
                    <div className="card-title font-medium text-sm m-none">Tự động hỏi và lưu địa chỉ giao hàng đối với khách hàng mới
                    </div>
                    <span className="card-subtitle text-xs m-none">
                      Thiết lập gửi tin nhắn tự động hỏi địa chỉ giao hàng đối với khách hàng chưa có thông tin địa chỉ
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          :
          <div className="setting-auto-reply-box">
            <div className={`switch-with-input interactive-message ${!editReEngagementMessages && "collapsed"}`}>
              <div className="switch-container">
                <div className="switch-wrapper d-flex-center">
                  <span>
                    <button type="button" className="app-switch app-switch-checked app-switch-disabled app-switch-small">
                      <span className="app-switch-inner"></span>
                      <div className="app-click-animating-node">
                      </div>
                    </button>
                  </span>
                </div>
                <div className="switch-title-container">
                  <div className="switch-title">
                    <div>
                      Tin nhắn thông báo sản phẩm trong giỏ hàng
                    </div>
                  </div>
                  <div className="switch-subtitle"></div>
                </div>
                <div className="reset-default-container">
                  {/* <span className="livestream-reset-default-button pointer">
                  <div className="svg-next-icon rotate-left ic-fb-menudot" >
                  </div>
                </span> */}
                </div>
              </div>
              <div className="input-container">
                <div className="input-title">
                  <div className="display-flex">
                    <span className="mr2">
                      Tin nhắn tái tương tác
                    </span>
                    {/* <span className="ml3 mr3 pointer">
                    <div className="svg-next-icon livestream-tooltip-image-icon mb3 icon-help-new">
                    </div>
                  </span> */}
                  </div>
                  <div className="input-subtitle">
                    Nếu khách hàng không có tương tác với Facebook Page Messenger trong 12 giờ, một tin nhắn tái tương tác sẽ được gửi trước khi gửi tin nhắn thông báo sản phẩm trong giỏ hàng.
                  </div>
                  <div className="button-collapse pointer" onClick={() => setEditReEngagementMessages(!editReEngagementMessages)}>
                    <span>
                      Chỉnh sửa tin nhắn tái tương tác
                    </span>
                    <span>
                      <div className={`svg-next-icon mb2 icon-expand-more ${!editReEngagementMessages && "svg-next-icon-rotate--180"}`}>
                      </div>
                    </span>
                  </div>
                </div>
                <div className="input-text input-text-none-scrollbar text-multi input-slate editor">
                  <SlateEditor
                    emoji={true}
                    control={true}
                    valueDefault={message_confirm_cart}
                    onChange={setMessageConfirmCart}
                    maxLength={640}
                  />
                </div>
              </div>
              <div className="input-button-container mt8">
                <div className="input-title">Tên nút:</div>
                <div className="input-text input-text-none-scrollbar text-single font-size-14 input-button editor">
                  <SlateEditor
                    emoji={true}
                    valueDefault={button_add_cart}
                    onChange={setButtonAddCart}
                    maxLength={20}
                  />
                </div>
              </div>
              <div style={{ position: "absolute", top: 0, left: 0, width: "100%" }}>
                <div>
                  <div className="app-tooltip  app-tooltip-placement-top  app-tooltip-hidden"
                    style={{ left: 400, top: 531, transformOrigin: "50% 50px" }}>
                    <div className="app-tooltip-content">
                      <div className="app-tooltip-arrow">
                      </div>
                      <div className="app-tooltip-inner" role="tooltip">
                        Cấu hình bắt buộc<br />đối với tin bán hàng
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="switch-with-input private-reply-view-cart">
              <div className="input-container">
                <div className="input-title">
                  <div className="display-flex">
                    <span className="mr2">
                      Tin nhắn thông báo sản phẩm trong giỏ hàng
                    </span>
                    {/* <span className="ml3 mr3 pointer">
                    <div className="svg-next-icon livestream-tooltip-image-icon mb3 icon-help-new">
                    </div>
                  </span> */}
                  </div>
                  <div className="input-subtitle">
                    Tự động gửi tin  nhắn thông báo khách hàng 1 lần trên 1 bài viết cho mỗi giỏ hàng mới được tạo.
                  </div>
                </div>
                <div className="input-text input-text-none-scrollbar text-multi input-slate editor" >
                  <SlateEditor
                    emoji={true}
                    control={true}
                    valueDefault={message_add_cart}
                    onChange={setMessageAddCart}
                    maxLength={640}
                  />
                  <div style={{ position: "absolute", top: 0, left: 0, width: "100%" }}>
                    <div>
                      <div className="app-tooltip  app-tooltip-placement-top  app-tooltip-hidden"
                        style={{ left: -29, top: 4, transformOrigin: "50% 50px" }}>
                        <div className="app-tooltip-content">
                          <div className="app-tooltip-arrow">
                          </div>
                          <div className="app-tooltip-inner" role="tooltip">
                            Thông tin chi tiết sản phẩm sẽ bao gồm tên sản phẩm, các biến thể (nếu có) và giá bán
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="input-button-container mt8">
                <div className="input-title">Tên nút:</div>
                <div className="input-text input-text-none-scrollbar text-single font-size-14 input-button editor">
                  <SlateEditor
                    emoji={true}
                    valueDefault={button_view_cart}
                    onChange={setButtonViewCart}
                    maxLength={20}
                  />
                </div>
              </div>
            </div>
            <div className="switch-with-input">
              <div className="setting-checkout-notify display-flex">
                <div className="switch-wrapper d-flex-center">
                  <button type="button" className="app-switch app-switch-checked app-switch-disabled app-switch-small">
                    <span className="app-switch-inner">
                    </span>
                    <div className="app-click-animating-node">
                    </div>
                  </button>
                </div>
                <div>
                  <div className="switch-title">
                    Tin nhắn thông báo xác nhận đơn hàng
                  </div>
                  <div className="confirm-template line-height-20 mt2">
                    <div className="display-flex">
                      <span className="text-font-weight-500">
                        Mẫu xác nhận đơn hàng của Facebook
                      </span>
                      <span className="ml5 pointer">
                        <div className="svg-next-icon ic-help mb3 icon-help-new" >
                        </div>
                      </span>
                    </div>
                    <div className="font-size-12">
                      Mẫu xác nhận sẽ được gửi nếu đơn hàng được tạo trong 24 giờ (trường hợp không sử dụng mẫu xác nhận Viettel Media) và sau 24 giờ khách hàng tương tác với trang.
                    </div>
                  </div>
                  <div className="confirm-template line-height-20 mt10">
                    <div className="display-flex">
                      <span className="text-font-weight-500">
                        Mẫu xác nhận đơn hàng
                      </span>
                      <span className="ml5 pointer">
                        <div className="svg-next-icon ic-help mb3 icon-help-new">
                        </div>
                      </span>
                    </div>
                    <div className="font-size-12">
                      Mẫu xác nhận sẽ được gửi nếu đơn hàng được tạo khi khách hàng tương tác với trang trong 24 giờ.</div>
                  </div>
                  {/* <a className="button-link" target="_blank">
                  <span>
                    Đến trang cài đặt
                  </span>
                  <span>
                    <div className="svg-next-icon mb2 ic_link">
                    </div>
                  </span>
                </a> */}
                </div>
              </div>
            </div>
            <div className="switch-with-input">
              <div className="switch-container">
                <div className="switch-wrapper d-flex-center">
                  <span>
                    <button type="button" className={`app-switch app-switch-small ${has_message_out_of_stock == 1 ? 'app-switch-checked' : 'app-switch'}`} onClick={() => setButtonOutOfStock(has_message_out_of_stock == 1 ? 0 : 1)}>
                      <span className="app-switch-inner"></span>
                      <div className="app-click-animating-node">
                      </div>
                    </button>
                  </span>
                </div>
                <div className="switch-title-container">
                  <div className="switch-title">
                    <div>
                      Tin nhắn phản hồi khi hết hàng
                    </div>
                  </div>
                  <div className="switch-subtitle">
                    Tự động gửi tin nhắn phản hồi khi sản phẩm đó hết số lượng mở bán trong một chiến dịch.
                  </div>
                </div>
                {/* <div className="reset-default-container">
                <span className="livestream-reset-default-button pointer">
                  <div className="svg-next-icon rotate-left ic-fb-menudot">
                  </div>
                </span>
              </div> */}
              </div>
              {has_message_out_of_stock == 1 &&
                <div className="input-container">
                  <div className="input-text input-text-none-scrollbar text-multi input-slate editor" >
                    <SlateEditor
                      emoji={true}
                      control={true}
                      valueDefault={content_message_out_of_stock}
                      onChange={setContentMessageOutOfStockCart}
                      maxLength={20}
                    />
                  </div>
                </div>
              }
            </div>
          </div>
        }
      </div>
    </div>
  )
}

const mapStateToProps = (state) => {
  const { settingPage } = state;

  return {
    settingPage
  };
};

export default connect(mapStateToProps, {
  setMessageAddCart,
  setButtonAddCart,
  setMessageConfirmCart,
  setButtonViewCart,
  setContentMessageOutOfStockCart,
  setButtonOutOfStock,
  setHasPrivateReplyAddress
})(SettingAutoReply);